import React, {useState, useEffect} from 'react';

import "./PDSACycle.css";
import changeIdeaIcon from "../../../../../resources/images/change-idea-icon.png";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import {PDSAPlanTabOne} from "./plan/pdsa-plan-tab-one/PDSAPlanTabOne";
import {PDSAPlanTabTwo} from "./plan/pdsa-plan-tab-two/PDSAPlanTabTwo";
import {PDSADoTabOne} from "./do/pdsa-do-tab-one/PDSADoTabOne";
import {PDSAStudyTabOne} from "./study/pdsa-study-tab-one/PDSAStudyTabOne";
import {PDSAActTabOne} from "./act/pdsa-act-tab-one/PDSAActTabOne";
import {createPDSA, updatePDSA} from "../../../../../services/PDSAService";
import {convertDateToUTC} from "../../../../../util/DateUtil";
import {PdsaDoTabTwo} from "./do/pdsa-do-tab-two/PDSADoTabTwo";

export const PDSACycle = ({
                              context,
                              setContext,
                              navigateTo,
                              setSpinnerText,
                              showToaster,
                              navigateBack,
                              toolTipsEnabled
                          }) => {

    const [activeTab, setActiveTab] = useState("plan");
    const [PDSA, setPDSA] = useState({});
    const [PDSACopy, setPDSACopy] = useState(null);
    const [currentScreen, setCurrentScreen] = useState("PDSAPlanTabOne");

    useEffect(() => {
        if (context.PDSAScreen) {
            const copyOfPDSAScreen = JSON.parse(JSON.stringify(context.PDSAScreen));

            if (copyOfPDSAScreen.testStartDate) {
                copyOfPDSAScreen.testStartDate = new Date(copyOfPDSAScreen.testStartDate);
            }

            if (copyOfPDSAScreen.testReviewDate) {
                copyOfPDSAScreen.testReviewDate = new Date(copyOfPDSAScreen.testReviewDate);
            }

            if (copyOfPDSAScreen.nextVisitDate) {
                copyOfPDSAScreen.nextVisitDate = new Date(copyOfPDSAScreen.nextVisitDate);
            }

            if (copyOfPDSAScreen.reviewDate) {
                copyOfPDSAScreen.reviewDate = new Date(copyOfPDSAScreen.reviewDate);
            }

            if (copyOfPDSAScreen.processMeasureList.length === 0) {
                copyOfPDSAScreen.processMeasureList = JSON.parse(JSON.stringify(context.changeIdeaScreen.processMeasureList));
            }

            setPDSA(copyOfPDSAScreen);
            setPDSACopy(copyOfPDSAScreen);
        } else {
            setPDSA({
                what: context.changeIdeaScreen.description,
                isActiveVersion: true,
                processMeasureList: JSON.parse(JSON.stringify(context.changeIdeaScreen.processMeasureList)),
            });
        }

        if (context.viewMode) {
            if (!context.copyOfPDSAScreen) {
                const copyOfPDSAScreen = JSON.stringify(context.PDSAScreen);
                setContext((prevState) => ({
                    ...prevState,
                    problemToBeViewedExternalReference: prevState.problemScreen.externalReference,
                    copyOfPDSAScreen,
                }));
            }
        } else {
            setContext((prevState) => ({
                ...prevState,
                problemToBeViewedExternalReference: prevState.problemScreen.externalReference,
            }));
        }
    }, []);

    const savePDSA = async (successCallback, versionPDSA) => {
        let status = null;
        if (PDSA.status && PDSA.status.label !== "In Progress") {
            const statusList = ["Abandon", "Adopt"];
            if (statusList.includes(PDSA.status.label)) {
                status = PDSA.status.label;
            } else {
                if (PDSA.rationale) {
                    status = PDSA.status.label;
                }
            }
        }

        let testStartDate = null;
        if (PDSA.testStartDate) {
            testStartDate = convertDateToUTC(PDSA.testStartDate);
        }

        let testReviewDate = null;
        if (PDSA.testReviewDate) {
            testReviewDate = convertDateToUTC(PDSA.testReviewDate);
        }

        let reviewDate = null;
        if (PDSA.reviewDate) {
            reviewDate = convertDateToUTC(PDSA.reviewDate);
        }

        const PDSAToBeSaved = {
            externalReference: PDSA.externalReference,
            name: PDSA.name,
            status,
            statusMovement: PDSA.statusMovement,
            changeIdeaExternalReference: context.changeIdeaScreen.externalReference,
            who: PDSA.who,
            what: PDSA.what,
            where: PDSA.where,
            testStartDate,
            testReviewDate,
            scale: PDSA.scale,
            reviewDate,
            processMeasures: PDSA.processMeasureList,
            observations: PDSA.observation,
            rationale: PDSA.rationale,
            analysis: PDSA.analysis,
            balanceMeasureA: PDSA.balancingMeasureOne,
            balanceMeasureB: PDSA.balancingMeasureTwo,
            balanceMeasureC: PDSA.balancingMeasureThree,
        }

        if (!PDSA.name) {
            PDSAToBeSaved.name = "PDSA 1A";
        }

        setSpinnerText("Saving PDSA");
        if (!PDSA.externalReference) {
            const [data, error] = await createPDSA(context.username, PDSAToBeSaved);
            if (data) {
                if (data.responseStatus === "Success") {
                    setPDSA((prevState) => ({
                        ...prevState,
                        externalReference: data.savedPDSAVO.externalReference,
                    }))
                    successCallback();
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        } else {
            if (versionPDSA) {
                const [data, error] = await updatePDSA(context.username, PDSAToBeSaved, versionPDSA);
                if (data) {
                    if (data.responseStatus === "Success") {
                        successCallback();
                    }
                    showToaster(data);
                } else {
                    showToaster({
                        responseStatus: "Error",
                        responseMessage: error.message,
                    });
                }
                setSpinnerText(null);
            } else {
                const copyOfPDSA = JSON.stringify(PDSACopy);
                const currentPDSA = JSON.stringify(PDSA);
                if (copyOfPDSA === currentPDSA) {
                    successCallback();
                    setSpinnerText(null);
                } else {
                    const [data, error] = await updatePDSA(context.username, PDSAToBeSaved, versionPDSA);
                    if (data) {
                        if (data.responseStatus === "Success") {
                            successCallback();
                        }
                        showToaster(data);
                    } else {
                        showToaster({
                            responseStatus: "Error",
                            responseMessage: error.message,
                        });
                    }
                    setSpinnerText(null);
                }
            }
        }
    }

    const screenMap = new Map();
    screenMap.set("PDSAPlanTabOne", <PDSAPlanTabOne context={context}
                                                    PDSA={PDSA}
                                                    setPDSA={setPDSA}
                                                    setContext={setContext}
                                                    navigateTo={navigateTo}
                                                    active={PDSA.isActiveVersion}
                                                    setCurrentScreen={setCurrentScreen}
                                                    navigateBack={navigateBack}
                                                    toolTipsEnabled={toolTipsEnabled}
                                                    setSpinnerText={setSpinnerText}
                                                    showToaster={showToaster}/>);
    screenMap.set("PDSAPlanTabTwo", <PDSAPlanTabTwo context={context}
                                                    PDSA={PDSA}
                                                    setPDSA={setPDSA}
                                                    savePDSA={savePDSA}
                                                    setContext={setContext}
                                                    navigateTo={navigateTo}
                                                    active={PDSA.isActiveVersion}
                                                    setCurrentScreen={setCurrentScreen}
                                                    setActiveTab={setActiveTab}
                                                    toolTipsEnabled={toolTipsEnabled}
                                                    setSpinnerText={setSpinnerText}
                                                    showToaster={showToaster}/>);
    screenMap.set("PDSADoTabOne", <PDSADoTabOne context={context}
                                                PDSA={PDSA}
                                                setPDSA={setPDSA}
                                                setContext={setContext}
                                                navigateTo={navigateTo}
                                                active={PDSA.isActiveVersion}
                                                setCurrentScreen={setCurrentScreen}
                                                setActiveTab={setActiveTab}
                                                toolTipsEnabled={toolTipsEnabled}
                                                showToaster={showToaster}
                                                setSpinnerText={setSpinnerText}/>);
    screenMap.set("PDSADoTabTwo", <PdsaDoTabTwo context={context}
                                                PDSA={PDSA}
                                                setPDSA={setPDSA}
                                                savePDSA={savePDSA}
                                                setContext={setContext}
                                                navigateTo={navigateTo}
                                                active={PDSA.isActiveVersion}
                                                setCurrentScreen={setCurrentScreen}
                                                setActiveTab={setActiveTab}
                                                toolTipsEnabled={toolTipsEnabled}
                                                showToaster={showToaster}
                                                setSpinnerText={setSpinnerText}/>);
    screenMap.set("PDSAStudyTabOne", <PDSAStudyTabOne context={context}
                                                      PDSA={PDSA}
                                                      setPDSA={setPDSA}
                                                      setSpinnerText={setSpinnerText}
                                                      setContext={setContext}
                                                      navigateTo={navigateTo}
                                                      savePDSA={savePDSA}
                                                      active={PDSA.isActiveVersion}
                                                      setCurrentScreen={setCurrentScreen}
                                                      setActiveTab={setActiveTab}
                                                      toolTipsEnabled={toolTipsEnabled}
                                                      showToaster={showToaster}/>);
    screenMap.set("PDSAActTabOne", <PDSAActTabOne context={context}
                                                  PDSA={PDSA}
                                                  setPDSA={setPDSA}
                                                  setSpinnerText={setSpinnerText}
                                                  showToaster={showToaster}
                                                  setContext={setContext}
                                                  navigateTo={navigateTo}
                                                  savePDSA={savePDSA}
                                                  active={PDSA.isActiveVersion}
                                                  setCurrentScreen={setCurrentScreen}
                                                  setActiveTab={setActiveTab}
                                                  toolTipsEnabled={toolTipsEnabled}/>);

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={changeIdeaIcon} alt="Change Idea Icon" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.changeIdeaScreen.title}</p>
                </div>
                <div className="pdsa-cycle-container">
                    <h2>{PDSA.name ? PDSA.name : "New PDSA"}</h2>
                    <div className="pdsa-tab-container">
                        <div className={"pdsa-tab " + (activeTab === "plan" ? "active-tab" : null)}>
                            Plan
                        </div>
                        <div className={"pdsa-tab " + (activeTab === "do" ? "active-tab" : null)}>
                            Do
                        </div>
                        <div className={"pdsa-tab " + (activeTab === "study" ? "active-tab" : null)}>
                            Study
                        </div>
                        <div className={"pdsa-tab " + (activeTab === "act" ? "active-tab" : null)}>
                            Act
                        </div>
                    </div>
                    <div className="pdsa-tab-content">
                        {screenMap.get(currentScreen)}
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
